export default __webpack_public_path__ + "static/media/ExerciseStatistics@2x.2147afcb.png";